import React from 'react'
import { Button, Col, Container, Nav, NavItem, NavLink, Row, UncontrolledTooltip } from 'reactstrap'

const Footer : React.FC = () => {
  return (
    <>
      <footer className="footer">
        <Container>
          <Row className="align-items-center justify-content-md-between">
            <Col md="4">
              <div className="copyright">
                © { new Date().getFullYear() }{ ' ' }
                <a
                  href="https://screen-me.cloud"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Screen.me
                </a>
                .
              </div>
            </Col>
            <Col className="text-lg-center btn-wrapper align-items-center" md="3" lg="3">
              <Button
                className="btn-icon-only rounded-circle"
                color="twitter"
                href="https://twitter.com/screenme"
                id="tooltip475038074"
                target="_blank"
              >
                <span className="btn-inner--icon">
                  <i className="fa fa-twitter"/>
                </span>
              </Button>
              <UncontrolledTooltip delay={ 0 } target="tooltip475038074">
                Follow us
              </UncontrolledTooltip>
              <Button
                className="btn-icon-only rounded-circle ml-1"
                color="facebook"
                href="https://www.facebook.com/screenme"
                id="tooltip837440414"
                target="_blank"
              >
                <span className="btn-inner--icon">
                  <i className="fa fa-facebook-square"/>
                </span>
              </Button>
              <UncontrolledTooltip delay={ 0 } target="tooltip837440414">
                Like us
              </UncontrolledTooltip>
              <Button
                className="btn-icon-only rounded-circle ml-1"
                color="dribbble"
                href="https://dribbble.com/screenme"
                id="tooltip829810202"
                target="_blank"
              >
                <span className="btn-inner--icon">
                  <i className="fa fa-dribbble"/>
                </span>
              </Button>
              <UncontrolledTooltip delay={ 0 } target="tooltip829810202">
                Follow us
              </UncontrolledTooltip>
              <Button
                className="btn-icon-only rounded-circle ml-1"
                color="github"
                href="https://github.com/Sorok-Dva/ScreenMe"
                id="tooltip495507257"
                target="_blank"
              >
                <span className="btn-inner--icon">
                  <i className="fa fa-github"/>
                </span>
              </Button>
              <UncontrolledTooltip delay={ 0 } target="tooltip495507257">
                Star on Github
              </UncontrolledTooltip>
            </Col>
            <Col md="4">
              <Nav className=" nav-footer justify-content-end">
                <NavItem>
                  <NavLink href="/privacy">
                    Privacy
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/terms-of-service">
                    Terms of Service
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/faq">
                    FAQ
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/help">
                    Help
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  )
}

export default Footer
